/**
 * 銀行口座情報編集画面: 「ゆうちょ銀行」のチェックに応じて入力欄を切り替える
 *
 * ゆうちょ銀行のときは金融機関名・コードを固定値にして読み取り専用にし、
 * 支店・口座番号の欄を隠して記号・番号の欄を表示する（必須属性も入れ替える）。
 * ゆうちょ銀行の金融機関コードはチェックボックスの data-yucho-bank-code で受け取る。
 *
 * @returns {void}
 */
const init_organization_bank_account = () => {
    const is_yucho_checkbox = document.getElementById('is_yucho')
    if (is_yucho_checkbox === null) return

    const yucho_bank_code = is_yucho_checkbox.dataset.yuchoBankCode
    const bank_code_input = document.getElementById('bank_code')
    const bank_name_input = document.getElementById('bank_name')

    // 各フィールドの要素を取得
    const branch_name_field = document.getElementById('branch-name-field')
    const branch_code_field = document.getElementById('branch-code-field')
    const branch_type_field = document.getElementById('branch-type-field')
    const account_number_field = document.getElementById('account-number-field')
    const yucho_symbol_field = document.getElementById('yucho-symbol-field')
    const yucho_number_field = document.getElementById('yucho-number-field')

    // 入力要素を取得
    const branch_code_input = document.getElementById('branch_code')
    const branch_type_select = document.getElementById('branch_type')
    const account_number_input = document.getElementById('account_number')
    const yucho_symbol_input = document.getElementById('yucho_symbol')
    const yucho_number_input = document.getElementById('yucho_number')

    const toggle_fields = () => {
        if (is_yucho_checkbox.checked) {
            // ゆうちょ銀行の場合
            bank_code_input.value = yucho_bank_code
            bank_name_input.value = 'ゆうちょ銀行'
            bank_code_input.setAttribute('readonly', 'readonly')
            bank_name_input.setAttribute('readonly', 'readonly')

            // フィールドの表示/非表示
            branch_name_field.style.display = 'none'
            branch_code_field.style.display = 'none'
            branch_type_field.style.display = 'none'
            account_number_field.style.display = 'none'
            yucho_symbol_field.style.display = 'block'
            yucho_number_field.style.display = 'block'

            // 必須属性を切り替え
            branch_code_input.removeAttribute('required')
            branch_type_select.removeAttribute('required')
            account_number_input.removeAttribute('required')
            yucho_symbol_input.setAttribute('required', 'required')
            yucho_number_input.setAttribute('required', 'required')
        } else {
            // 通常の銀行の場合
            bank_code_input.removeAttribute('readonly')
            bank_name_input.removeAttribute('readonly')

            // フィールドの表示/非表示
            branch_name_field.style.display = 'block'
            branch_code_field.style.display = 'block'
            branch_type_field.style.display = 'block'
            account_number_field.style.display = 'block'
            yucho_symbol_field.style.display = 'none'
            yucho_number_field.style.display = 'none'

            // 必須属性を切り替え
            branch_code_input.setAttribute('required', 'required')
            branch_type_select.setAttribute('required', 'required')
            account_number_input.setAttribute('required', 'required')
            yucho_symbol_input.removeAttribute('required')
            yucho_number_input.removeAttribute('required')
        }
    }

    // 初期状態を設定
    toggle_fields()

    // チェックボックス変更時に切り替え
    is_yucho_checkbox.addEventListener('change', toggle_fields)
}

document.addEventListener('DOMContentLoaded', init_organization_bank_account)
